import React from 'react';

const SearchField = (props) => {
  return (
    <input type="search" {...props}/>
  );
};

export default SearchField;
